// ** Redux Imports
/* eslint-disable */
import rootReducer from "./rootReducer"
import { configureStore} from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ['layout', 'navbar'],
  version: 2,
  migrate: async state => state ? { layout: state.layout, navbar: state.navbar, _persist: state._persist } : state,
  // Optionally, you can blacklist/whitelist specific reducers
  // whitelist: ['someReducer'],
  // blacklist: ['someReducer'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export { store, persistor };
